import yup from "src/validators/yup.Module";

export enum EModulo {
  Fiscal = 0,
}

export enum ESubModulo {
  NFCe = 0,
}

export interface RelatorioDto {
  id: number;
  modulo: EModulo;
  subModulo: ESubModulo;
  nome: string;
}

export interface RelatorioImprimirInput<T = any> {
  id: number;
  data: T;
}

export interface RelatorioIncluirInput {
  id?: number;
  modulo: EModulo;
  subModulo: ESubModulo;
  nome: string;
  arquivo: string; // Base64 string
}

export const RelatorioIncluirSchema = yup.object().shape({
  id: yup.number().optional(),
  nome: yup.string().required("O nome é obrigatório"),
  modulo: yup.number().required("O módulo é obrigatório"),
  subModulo: yup.number().required("O submódulo é obrigatório"),
  arquivo: yup.string().required("O arquivo é obrigatório"),
});

export const moduloOptions = [
  { value: EModulo.Fiscal.toString(), label: "Fiscal" },
];

export const subModuloOptions = [
  { value: ESubModulo.NFCe.toString(), label: "NFCe" },
];
